import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import CreateUserPage from "./CreateUserForm";
import EditUserPage from "./EditUserForm";

export const UserModule = () => {
    let { path } = useRouteMatch();

    return (
    
      <Switch>
      <ProtectedRoute exact path={path}>
            <CreateUserPage />
      </ProtectedRoute> 
      <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
            <EditUserPage />
      </ProtectedRoute>
     
    </Switch>
      
    );
  };
  
  export default UserModule;